import { render, staticRenderFns } from "./EvaluationWizardTab.vue?vue&type=template&id=4a1f15de&"
import script from "./EvaluationWizardTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationWizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports